import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CBTGCOFOH_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cbtgcofoh/logo.png",
        alt: "Cognitive & Behavioral Therapy of Greater Columbus Inc. Logo",
        style: { width: "150px", height: "100%", isMobile: { width: "100px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 26,
  state: "OH",
  departmentIds: [100, 107, 112, 113, 122, 105],
};
